//TODO: will change with EP later
import {
  genderOptions,
  maritalStatusOptions,
  workSectorOptions,
  countryOptions,
} from '@/constants/pdp';

import { Form, Formik } from 'formik';
import Input from '@/components/ui/inputFormik';
import Logo from '@/layout/header/navbar/logo';
import { rabehLoyaltyValidation } from '@/utils/validation/rabeh-loyalty';
import { useEffect, useState } from 'react';
import InputMobile from '@/components/ui/inputFormik/input-mobile';
import SelectInputFormik from '@/components/ui/inputFormik/select-input-formik';
import { rabahCreateAccount } from '@/services/product';
import { toast } from '@/utils/toast';
import { getCookie } from 'cookies-next';

const RabehForm = ({ t, locale, setShowSuccessModal, setIsModalOpen }) => {
  const mage = getCookie('mage');

  // Localized options state
  const [localizedOptions, setLocalizedOptions] = useState({
    gender: [],
    maritalStatus: [],
    workSector: [],
    country: [],
  });

  useEffect(() => {
    const localize = (arr) =>
      arr.map((e) => ({
        value: e.value,
        label: e[`label-${locale}`],
      }));

    setLocalizedOptions({
      gender: localize(genderOptions),
      maritalStatus: localize(maritalStatusOptions),
      workSector: localize(workSectorOptions),
      country: localize(countryOptions),
    });
  }, [locale]);

  const initialValues = {
    name: '',
    country: '',
    gender: '',
    dob: '',
    phone_number: '',
    email: '',
    marital_status: '',
    profession: '',
    acceptedTerms: false,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      name: values.name,
      country: values.country,
      gender: values.gender,
      dob: values.dob,
      phone_number: `00966${values.phone_number}`,
      email: values.email,
      marital_status: values.marital_status,
      profession: values.profession,
    };

    const res = await rabahCreateAccount(payload, mage);

    if (!res?.data || res?.error?.error || res.data?.data?.status == false) {
      toast.error(
        res?.error?.error?.message ||
          res.data?.data?.message ||
          t('unknwen_error_key')
      );
    } else {
      toast.success(t('account_created'));
      setShowSuccessModal(true);
    }
    setSubmitting(false);
  };
  return (
    <>
      <div className='flex items-center justify-center pt-4 pb-3'>
        <Logo />
      </div>
      <Formik
        onSubmit={handleSubmit}
        validationSchema={rabehLoyaltyValidation(t)}
        initialValues={initialValues}
      >
        {({ isSubmitting, setFieldValue, errors, touched }) => (
          <Form>
            <div className='flex flex-col gap-2 px-2 pb-4 lg:gap-4 lg:px-6'>
              <Input name='name' id='name' title={t('name')} />
              <SelectInputFormik
                errors={errors}
                handleChange={(e) => {
                  setFieldValue('country', e.value);
                }}
                name='country'
                id='country'
                options={localizedOptions.country}
                title={t('country')}
                touched={touched}
              />
              <SelectInputFormik
                errors={errors}
                handleChange={(e) => {
                  setFieldValue('gender', e.value);
                }}
                name='gender'
                id='gender'
                options={localizedOptions.gender}
                title={t('select_gender')}
                touched={touched}
              />
              <Input type='date' name='dob' id='dob' title={t('birth_date')} />

              <InputMobile
                id='phone_number'
                name='phone_number'
                title={t('mobile_number')}
                labelClassName='font-normal'
              />

              <Input name='email' id='email' title={t('Email')} />

              <SelectInputFormik
                errors={errors}
                handleChange={(e) => {
                  setFieldValue('marital_status', e.value);
                }}
                name='marital_status'
                id='marital_status'
                options={localizedOptions.maritalStatus}
                title={t('marital_status')}
                touched={touched}
              />

              <SelectInputFormik
                errors={errors}
                handleChange={(e) => {
                  setFieldValue('profession', e.value);
                }}
                name='profession'
                id='profession'
                options={localizedOptions.workSector}
                title={t('work_sector')}
                touched={touched}
              />

              <Input
                type='checkbox'
                name='acceptedTerms'
                title={
                  <span className='text-[#525050] max-lg:text-lg max-md:text-sm max-sm:text-xs'>
                    {t('I Agree to')}{' '}
                    <span className='font-bold text-black underline'>
                      {t('Terms and Conditions')}
                    </span>
                  </span>
                }
              />
            </div>

            <div className='flex items-center justify-between gap-2.5 border-t border-[#DDDDDD] px-2 py-3.75 lg:px-6'>
              <button
                type='submit'
                disabled={isSubmitting}
                className='bg-primary hover:bg-primary-900 flex w-60 cursor-pointer items-center justify-center gap-2 rounded-lg font-bold text-white disabled:cursor-not-allowed disabled:opacity-50 max-lg:py-2 max-md:h-9 max-md:text-[15px] max-sm:rounded-[10px] max-sm:py-2 max-sm:text-sm lg:py-3'
              >
                {isSubmitting && (
                  <span className='size-4 animate-spin rounded-full border-t border-r border-white py-1 max-lg:size-2' />
                )}
                {t('join_now')}
              </button>
              <button
                onClick={() => setIsModalOpen(false)}
                className='rounded-[5px] border border-[#BBBBBB] px-13 text-[15px] text-[#111111] shadow-[inset_0px_1px_0px_1px_#ffffff4c] [background:linear-gradient(180deg,rgba(247,248,250,1)_0%,rgba(231,233,236,1)_100%)] max-lg:py-2 max-md:h-9 max-sm:rounded-[10px] max-sm:py-2 max-sm:text-[13px] lg:py-3'
              >
                {t('cancel_key')}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default RabehForm;
